import { useSelector } from "react-redux";

import { boxContainer, Spacer, application } from "../../components";

import { Images } from "../../config";

const StudentGeneral = () => {
  const { student } = useSelector((state) => state?.students);

  const topData = [
    {
      title: "Country of Preference 1",
      value: student?.general?.questionnaire?.countryPreference[0] ?? "NA",
      icon: Images?.StudentGeneralCountryPref,
    },
    {
      title: "Country of Preference 2",
      value: student?.general?.questionnaire?.countryPreference[1] ?? "NA",
      icon: Images?.StudentGeneralCountryPref,
    },
    {
      title: "Country of Preference 3",
      value: student?.general?.questionnaire?.countryPreference[2] ?? "NA",
      icon: Images?.StudentGeneralCountryPref,
    },
    {
      title: "Degree of Preference",
      value: student?.general?.questionnaire?.majorsInterested[0] ?? "NA",
      icon: Images?.StudentGeneralDegreePref,
    },
  ];

  return (
    <div className="px-6 py-4">
      <div className="flex gap-6 w-full justify-between">
        {topData?.map((item, index) => (
          <boxContainer.LiteBoxContainer key={index} addstyle="flex flex-1">
            <div className="flex flex-col gap-2 px-2 w-full">
              <div className="student-box-title text-dot" title={item?.title}>
                {item?.title}
              </div>
              <div className="flex justify-between items-center">
                <div className="text-dot student-box-value" title={item?.value}>
                  {item?.value}
                </div>
                <img src={item?.icon} className="h-[2em]" />
              </div>
            </div>
          </boxContainer.LiteBoxContainer>
        ))}
      </div>
      <Spacer height={20} />
      <div className="student-headers">
        Upcoming Deadline for Shortlisted Universities
      </div>
      <Spacer height={20} />
      <div className="max-h-[37.5em] overflow-auto flex flex-col gap-4">
        {student?.general?.deadlines?.map((item, index) => (
          <application.StudentDeadlineRow item={item} key={index} />
        ))}
      </div>
    </div>
  );
};

export default StudentGeneral;
